import React, { useEffect, useState } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import Modal from "react-responsive-modal";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { CierreInventarioApi } from "./api/CierreInventarioApi";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { CONFIG_TEXTOS_ACOPIO } from "../../../../config/textosAcopio";

export const CierreInventarioForm = (props) => {
    const {
        opened,
        onClose,
        inventarioId,
        fechaInicial,
        fechaFinal,
        GetAlmacenesInventario,
        onSuccess,
        categoriaAcopio,
    } = props;

    const textConfig = CONFIG_TEXTOS_ACOPIO[categoriaAcopio];

    const [totalesProduccion, setTotalesProduccion] = useState([]);

    const { getTotalesEnviadosProduccion, cerrarInventario, cargando } =
        CierreInventarioApi();

    const CerrarInventario = async () => {
        try {
            // Si la fecha final es menor a la fecha inicial, mostrar error y no guardar
            if (
                fechaFinal &&
                fechaInicial &&
                moment(fechaFinal).isBefore(fechaInicial, "day")
            ) {
                NotificationManager.error(
                    "La fecha final debe ser posterior a la fecha inicial",
                    "Error",
                    3000,
                );
                GetAlmacenesInventario();
                return;
            }

            // no se guarda otra vez el inventario porque ya se actualiza solo con cambiar la fecha final.
            await cerrarInventario(inventarioId);

            NotificationManager.success(
                "Inventario cerrado correctamente",
                "Éxito",
                3000,
            );

            if (!!onSuccess) onSuccess();

            onClose();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cerrar el inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            // Refrescar la información por si hay nuevos almacenes pendientes
            GetAlmacenesInventario();
        }
    };

    const GetTotalesProduccion = async () => {
        try {
            const response = await getTotalesEnviadosProduccion(inventarioId);
            setTotalesProduccion(response || []);
        } catch (error) {
            console.log("Error al obtener totales de producción:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los totales de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setTotalesProduccion([]);
        }
    };

    useEffect(() => {
        if (opened) GetTotalesProduccion();
    }, [opened]);

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
            styles={{
                modal: {
                    width: "550px",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h5 className="text-center mb-3">Cierre de inventario</h5>

                <div className="mb-3">
                    <p className="mb-2 font-weight-600 text-justify">
                        Al cerrar el inventario, no se podrán hacer más cambios
                        en los almacenes. Tampoco se podrá eliminar el
                        inventario.
                    </p>
                    <p className="mb-0">
                        ¿Desea cerrar el inventario con los siguientes totales?
                    </p>
                </div>

                <div className="mb-3 d-flex align-items-center gap-10 justify-content-center">
                    <label className="mb-0 pl-0">Periodo:</label>
                    <span>
                        {fechaInicial
                            ? moment(fechaInicial).format("DD/MM/YYYY")
                            : "N/A"}{" "}
                        -{" "}
                        {fechaFinal
                            ? moment(fechaFinal).format("DD/MM/YYYY")
                            : "N/A"}
                    </span>
                </div>

                <div className="new-table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th
                                    rowSpan={2}
                                    className="text-nowrap cell-border-right"
                                >
                                    Padre producto terminado
                                </th>
                                <th colSpan={2} className="text-nowrap">
                                    {textConfig.textoEnvio}
                                </th>
                            </tr>
                            <tr>
                                <th>Laboratorio</th>
                                <th>Liquidación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalesProduccion.length === 0 && (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        No hay almacenes con padres de producto terminado
                                    </td>
                                </tr>
                            )}
                            {totalesProduccion.map((total) => (
                                <tr>
                                    <td className="text-center cell-border-right">
                                        {total.padre_producto_terminado_nombre}
                                    </td>
                                    <td className="text-center">
                                        <RenderKilogramo
                                            value={total.total_enviado_lab || 0}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <RenderKilogramo
                                            value={total.total_enviado_liq || 0}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Regresar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={CerrarInventario}
                    >
                        Cerrar inventario
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
